/**
 * @generated SignedSource<<7811469895b8b7c71c9f0638d5075772>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type shopifyAppEmbedBannerQuery$variables = Record<PropertyKey, never>;
export type shopifyAppEmbedBannerQuery$data = {
  readonly shopifyAppEmbedsToEnable: ReadonlyArray<{
    readonly appEmbedDeepLink: string;
    readonly salesChannelID: string;
    readonly shop: string;
  }>;
};
export type shopifyAppEmbedBannerQuery = {
  response: shopifyAppEmbedBannerQuery$data;
  variables: shopifyAppEmbedBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ShopifyAppEmbedToEnable",
    "kind": "LinkedField",
    "name": "shopifyAppEmbedsToEnable",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesChannelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shop",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appEmbedDeepLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "shopifyAppEmbedBannerQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "shopifyAppEmbedBannerQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "7dce653af2a98c623321735ecc4e8250",
    "id": null,
    "metadata": {},
    "name": "shopifyAppEmbedBannerQuery",
    "operationKind": "query",
    "text": "query shopifyAppEmbedBannerQuery {\n  shopifyAppEmbedsToEnable {\n    salesChannelID\n    shop\n    appEmbedDeepLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca2bf575aaec1a3b724901e1907e1a13";

export default node;
